export default {
  name: 'billing-history-invoice-list-item',
  props: {
    invoice: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getInvoicePaidType(invoice) {
      switch (invoice.paid) {
        case true:
          return 'GREEN';
        case false:
          return 'RED';
        default:
          return 'GRAY';
      }
    },
  },
};
